// extracted by mini-css-extract-plugin
export default {"invalid-error":"PAndIForm_invalid-error__QX1eG","submitBtn":"PAndIForm_submitBtn__sUOJJ"};